<script>
import Layout from '@layouts/main.vue'
import {
  authComputed,
  kidMethods,
  kidComputed,
  volunteerMethods,
  volunteerComputed,
  dutyMethods,
  shiftComputed,
  shiftMethods,
  cityMethods,
  cityComputed,
} from '@state/helpers'
import dayjs from 'dayjs'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/lt'

export default {
  page: {
    title: 'Grafikas',
  },

  components: { Layout, DatePicker },

  data() {
    return {
      pageTitle: 'Grafikas',
      showPhoneNumbers: true,
      city: null,
      datePickerDate: null,
      kidId: null,
      duties: null,
      volunteerID: null,
      expandedKids: {},
      dayChange: 1,
      dayOptions: [
        {
          id: 1,
          label: '1d',
        },
        {
          id: 7,
          label: '7d',
        },
      ],
      dialogs: {
        volunteer: {
          visible: false,
          id: null,
          kid: null,
          volunteerId: null,
          action: null,
        },
        shift: {
          visible: false,
          dutyId: null,
          kidId: null,
          userId: null,
          shiftId: null,
          modifyTime: false,
          hourFrom: null,
          minuteFrom: null,
          hourTo: null,
          minuteTo: null,
          dutyCell: null,
        },
        update: {
          visible: false,
          dutyCell: null,
          kidId: null,
          userId: null,
        },
        reason: {
          visible: false,
          text: null,
        },
      },
    }
  },

  computed: {
    ...authComputed,

    ...kidComputed,

    ...volunteerComputed,

    ...shiftComputed,

    ...cityComputed,

    dayNames() {
      if (!this.kids || !this.kids.length) return []

      const dayNames = ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
      const result = []
      for (let i = 0; i < 7; i += 1) {
        result.push(dayNames[this.kids[0].duties[i].week_day % 7])
      }
      return result
    },

    dateTitle() {
      const months = [
        '',
        'Sausis',
        'Vasaris',
        'Kovas',
        'Balandis',
        'Gegužė',
        'Birželis',
        'Liepa',
        'Rugpjūtis',
        'Rugsėjis',
        'Spalis',
        'Lapkritis',
        'Gruodis',
      ]

      const year = dayjs(this.date).format('YYYY')
      const month = months[dayjs(this.date).format('M')]
      return `${year} ${month}`
    },

    freeShiftOptions() {
      let reservedOptions = []
      if (this.dialogs.shift.dutyCell && this.dialogs.shift.dutyCell.duties) {
        reservedOptions = this.dialogs.shift.dutyCell.duties.map(
          (x) => x.shift_title,
        )
      }
      return this.shiftOptions.filter(
        (option) => !reservedOptions.includes(option.label),
      )
    },

    hoursFromOptions() {
      const result = []
      for (let i = 1; i < 25; i++) {
        result.push({
          id: i % 24,
          label: i % 24,
        })
      }
      return result
    },

    hoursToOptions() {
      const result = []
      for (let i = 1; i < 25; i++) {
        result.push({
          id: i % 24,
          label: i % 24,
        })
      }
      return result
    },

    minuteOptions() {
      return [
        {
          id: 0,
          label: '00',
        },
        {
          id: 30,
          label: '30',
        },
      ]
    },

    isInstitution() {
      return this.$route.fullPath.includes('/grafikas/kc')
    },
  },

  created() {
    if (this.currentUser.programs.toString() == 'drauge') {
      this.$router.push('/savanoriai')
      return
    }

    this.datePickerDate = dayjs().format('YYYY-MM-DD')
    this.date = dayjs()
    this.loadCity()
    this.loadKidsList()
    this.loadVolunteers()
    this.fetchAllShifts({ city: this.city })
    this.fetchAllCities()

    if (this.isInstitution) {
      this.pageTitle = 'KC grafikas'
    } else {
      this.pageTitle = 'Ligoninių grafikas'
    }
  },

  methods: {
    ...kidMethods,

    ...volunteerMethods,

    ...dutyMethods,

    ...shiftMethods,

    ...cityMethods,

    loadCity() {
      this.city = this.currentUser.city
    },

    loadKidsList() {
      this.datePickerDate = this.date.format('YYYY-MM-DD')
      this.fetchAllKids({
        start_date: this.date.format('YYYY-MM-DD'),
        city: this.city,
        ...(!this.isInstitution && {
          program: 'nv',
        }),
        ...(this.isInstitution && {
          program: 'kc',
        }),
      })
    },

    loadVolunteers() {
      this.fetchAllVolunteers({
        sort: 'first_name',
        per_page: 10000,
        city: this.city,
      })
    },

    onClickPrevWeek() {
      this.date = dayjs(this.date).subtract(this.dayChange, 'days')
      this.loadKidsList()
    },

    onClickNextWeek() {
      this.date = dayjs(this.date).add(this.dayChange, 'days')
      this.loadKidsList()
    },

    onClickAddVolunteer(kid) {
      this.dialogs.volunteer.kid = kid
      this.dialogs.volunteer.action = 'add'
      this.dialogs.volunteer.visible = true
    },

    onSubmitVolunteer() {
      this.dialogs.volunteer.visible = false

      if (this.dialogs.volunteer.action === 'edit') {
        this.updateVolunteer({
          kid_id: this.dialogs.volunteer.kid.id,
          user_id: this.dialogs.volunteer.volunteerId,
          id: this.dialogs.volunteer.id,
        }).then(this.loadKidsList)

        this.originalVolunteerID = null
      } else {
        this.createVolunteer({
          kid_id: this.dialogs.volunteer.kid.id,
          user_id: this.dialogs.volunteer.volunteerId,
        }).then(this.loadKidsList)
      }
    },

    onClickDeleteVolunteer() {
      if (confirm('Ar tikrai norite pašalinti šį savanorį?')) {
        this.deleteVolunteer({
          kid_id: this.dialogs.volunteer.kid.id,
          id: this.dialogs.volunteer.id,
        }).then(() => {
          this.dialogs.volunteer.visible = false
          this.loadKidsList()
        })
      }
    },

    onClickEditVolunteer(kid, id) {
      this.dialogs.volunteer.kid = kid
      this.dialogs.volunteer.id = id
      this.dialogs.volunteer.visible = true
      this.dialogs.volunteer.action = 'edit'
    },

    dutyCells(kidId, volunteerID) {
      const result = []
      for (let i = 0; i < 7; i += 1) {
        const kid = this.kids.find(({ id }) => id === kidId)
        const duties = kid.duties[i].volunteers.filter(
          (v) => v.user_id === volunteerID,
        )
        if (duties.length) {
          const dutyKid = duties.find(({ kid_id }) => kid_id === kid.id)
          if (dutyKid) {
            const dutyKids = duties
              .filter(({ kid_id }) => kid_id === kid.id)
              .sort((a, b) => {
                const x = parseInt(a.hours.split('-')[0])
                const y = parseInt(b.hours.split('-')[0])
                return x > y ? 1 : -1
              })

            let color = 'gray'
            if (dutyKids[0].shift_title === '7-12') color = 'yellow'
            if (dutyKids[0].shift_title === '12-17') color = 'orange'
            if (dutyKids[0].shift_title === '17-22') color = 'blue'
            if (dutyKids[0].shift_title === '22-7') color = 'purple'

            result.push({
              state: 'busy',
              hours: dutyKids.map(({ hours }) => hours).join(', '),
              color,
              kid: kidId,
              date: kid.duties[i].date,
              duties,
              can_apply: kid.duties[i].can_apply,
            })
          } else {
            result.push({
              state: 'free',
              kid: kidId,
              can_apply: kid.duties[i].can_apply,
              date: kid.duties[i].date,
            })
          }
        } else {
          result.push({
            state: 'free',
            kid: kidId,
            can_apply: kid.duties[i].can_apply,
            date: kid.duties[i].date,
          })
        }
      }
      return result
    },

    onClickReserveTime(kidId, userId, dutyCell) {
      if (this.currentUser.role === 'volunteer') return

      if (dutyCell.state === 'busy') {
        this.dialogs.update.kidId = kidId
        this.dialogs.update.userId = userId
        dutyCell.duties = dutyCell.duties.sort((a, b) => {
          const x = parseInt(a.hours.split('-')[0])
          const y = parseInt(b.hours.split('-')[0])
          return x > y ? 1 : -1
        })
        this.dialogs.update.dutyCell = dutyCell
        this.dialogs.update.visible = true
      } else {
        this.onClickAddTime(kidId, userId, dutyCell)
      }
    },

    onClickAddTime(kidId, userId, dutyCell) {
      this.dialogs.update.visible = false

      this.dialogs.shift.dutyCell = dutyCell
      this.dialogs.shift.kidId = kidId
      this.dialogs.shift.userId = userId
      this.dialogs.shift.date = dutyCell.date
      this.dialogs.shift.action = 'add'

      // Hide duties that are already reserved for this volunteer
      this.dialogs.shift.dutyCell.duties = this.kids
        .map((kid) =>
          kid.duties
            .map((duty) => duty.volunteers.map((volunteer) => volunteer))
            .flat(),
        )
        .flat()
        .filter(
          (duty) => duty.user_id === userId && duty.date === dutyCell.date,
        )

      this.dialogs.shift.visible = true
    },

    onClickDutyEdit(duty) {
      this.dialogs.shift.dutyId = duty.id
      this.dialogs.shift.kidId = this.dialogs.update.kidId
      this.dialogs.shift.userId = this.dialogs.update.userId
      this.dialogs.shift.shiftId = duty.shift_id
      this.dialogs.shift.modifyTime = !!duty.hour_from
      if (duty.hour_from) {
        this.dialogs.shift.hourFrom = duty.hour_from
        this.dialogs.shift.hourTo = duty.hour_to
        this.dialogs.shift.minuteFrom = duty.minute_from
        this.dialogs.shift.minuteTo = duty.minute_to
      }
      this.dialogs.shift.date = duty.date
      this.dialogs.shift.action = 'update'
      this.dialogs.update.visible = false
      this.dialogs.shift.visible = true
    },

    filteredVolunteerOptions() {
      const kidVolunteers = this.dialogs.volunteer.kid.volunteers.map(
        ({ user_id }) => user_id,
      )
      return this.volunteerOptions.filter(
        ({ id }) => !kidVolunteers.includes(id),
      )
    },

    onSubmitDutyTake() {
      const action =
        this.dialogs.shift.action === 'add' ? this.createDuty : this.updateDuty
      action({
        id: this.dialogs.shift.dutyId,
        kid_id: this.dialogs.shift.kidId,
        date: this.dialogs.shift.date,
        shift_id: this.dialogs.shift.shiftId,
        user_id: this.dialogs.shift.userId,
        hour_from: this.dialogs.shift.modifyTime
          ? this.dialogs.shift.hourFrom
          : null,
        hour_to: this.dialogs.shift.modifyTime
          ? this.dialogs.shift.hourTo
          : null,
        minute_from: this.dialogs.shift.modifyTime
          ? this.dialogs.shift.minuteFrom
          : 0,
        minute_to: this.dialogs.shift.modifyTime
          ? this.dialogs.shift.minuteTo
          : 0,
        ...(this.isInstitution && {
          kc_program: true,
        }),
        ...(!this.isInstitution && {
          nv_program: true,
        }),
      }).then(() => {
        this.loadKidsList()
        this.dialogs.shift.visible = false
      })
    },

    onCloseShiftsDialog() {
      this.dialogs.shift.visible = false
    },

    onSubmitDutyDelete() {
      this.dialogs.reason.visible = true
      this.dialogs.shift.visible = false
    },

    onShiftChange(val) {
      const shift = this.freeShiftOptions.find(({ id }) => id === val)
      const hourFrom = parseInt(shift.label.split('-')[0])
      const hourTo = parseInt(shift.label.split('-')[1])

      this.dialogs.shift.hourFrom = hourFrom
      this.dialogs.shift.hourTo = hourTo
      this.dialogs.shift.minuteFrom = 0
      this.dialogs.shift.minuteTo = 0
    },

    onChangeCity() {
      this.loadKidsList()
      this.fetchAllShifts({ city: this.city })
    },

    onSubmitCancelReason() {
      this.deleteDuty({
        id: this.dialogs.shift.dutyId,
        reason: this.dialogs.reason.text,
      }).then(() => {
        this.loadKidsList()
        this.dialogs.reason.text = ''
        this.dialogs.reason.visible = false
      })
    },

    onClickShowKid(kidId) {
      this.$set(this.expandedKids, kidId, true)
    },

    onClickHideKid(kidId) {
      this.$set(this.expandedKids, kidId, false)
    },

    onDateChange(date) {
      this.date = dayjs(date)
      this.loadKidsList()
    },
  },
}
</script>

<template>
  <Layout>
    <base-page-title>
      <template v-slot:title>
        <div class="text-2xl font-bold">{{ pageTitle }}</div>
        <div>
          <div
            v-if="showPhoneNumbers"
            class="text-gray-700 text-xs flex flex-row items-center space-x-1 cursor-pointer"
            @click="showPhoneNumbers = !showPhoneNumbers"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
            <div> Slėpti numerius </div>
          </div>
          <div
            v-else
            class="text-gray-700 text-xs flex flex-row items-center space-x-1 cursor-pointer"
            @click="showPhoneNumbers = !showPhoneNumbers"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-3 w-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
              />
            </svg>
            <div> Rodyti numerius </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="flex flex-col lg:flex-row">
          <div class="mb-2">
            <div class="text-xl mr-2 inline-block pt-2">{{ dateTitle }}</div>
            <div class="w-12 inline-block">
              <base-btn class="mr-2" @click="onClickPrevWeek">
                <font-awesome-icon :icon="['fas', 'chevron-left']" />
              </base-btn>
            </div>
            <div class="w-12 inline-block ml-2">
              <base-btn @click="onClickNextWeek">
                <font-awesome-icon :icon="['fas', 'chevron-right']" />
              </base-btn>
            </div>
          </div>
          <div
            v-if="
              currentUser.role === 'admin' || currentUser.role === 'coordinator'
            "
            class="lg:ml-2 mb-4 w-full lg:w-16"
          >
            <base-select v-model="dayChange" :options="dayOptions || []" />
          </div>
          <div
            v-if="
              currentUser.role === 'admin' || currentUser.role === 'coordinator'
            "
            class="lg:ml-2 mb-4 w-full lg:w-40 datepicker"
          >
            <DatePicker
              v-model="datePickerDate"
              value-type="format"
              format="YYYY-MM-DD"
              @change="onDateChange"
            />
          </div>
          <div
            v-if="currentUser.role === 'admin'"
            class="lg:ml-2 mb-4 w-full lg:w-40"
          >
            <base-select
              v-model="city"
              :options="cityOptions || []"
              type="text"
              @change="onChangeCity"
            />
          </div>
        </div>
        <div class="lg:flex lg:flex-row">
          <div
            v-if="
              currentUser.role !== 'volunteer' &&
              !$route.fullPath.includes('/grafikas/kc')
            "
            class="hide-on-print"
          >
            <base-btn
              class="lg:ml-2 py-3 px-4"
              @click="$router.push({ name: 'kid-create' })"
            >
              <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />
              Pridėti vaiką
            </base-btn>
          </div>
          <div
            v-if="
              currentUser.role !== 'volunteer' &&
              $route.fullPath.includes('/grafikas/kc')
            "
            class="hide-on-print"
          >
            <base-btn
              class="lg:ml-2 py-3 px-4"
              @click="$router.push({ name: 'institution-create' })"
            >
              <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />
              Pridėti įstaigą
            </base-btn>
          </div>
        </div>
      </template>
    </base-page-title>

    <div class="-mx-4 lg:-mx-8">
      <div v-if="kids && kids.length" class="overflow-x-auto">
        <div
          v-for="kid in kids"
          :key="kid.id"
          :class="{ 'cursor-pointer': !expandedKids[kid.id] }"
        >
          <table class="table-auto w-full" @click="onClickShowKid(kid.id)">
            <thead v-if="expandedKids[kid.id]">
              <tr>
                <th class="text-left w-full">{{
                  kid.institution ? 'Įstaiga' : 'Vaikas'
                }}</th>
                <th>
                  <div class="flex flex-row">
                    <div class="flex-1 flex items-center w-24 mr-12">
                      Savanoris
                    </div>
                    <div
                      v-for="(day, dayIndex) in dayNames"
                      :key="dayIndex"
                      class="text-center w-20 mr-1"
                    >
                      {{ day }}
                      <br />
                      {{ kids[0].duties[dayIndex].date.split('-')[2] }}
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border text-sm">
                <td class="align-top">
                  <template v-if="expandedKids[kid.id]">
                    <router-link
                      v-if="currentUser.role !== 'volunteer'"
                      :to="{ name: 'kid-edit', params: { id: kid.id } }"
                      class="text-lg"
                    >
                      {{ kid.full_name }} {{ kid.institution }}
                    </router-link>
                    <div v-else class="text-lg print:text-sm">
                      {{ kid.full_name }} {{ kid.institution }}
                    </div>
                    <font-awesome-icon
                      :icon="['fas', 'chevron-up']"
                      class="ml-1 cursor-pointer"
                      @click.stop="onClickHideKid(kid.id)"
                    />
                  </template>
                  <template v-else>
                    {{ kid.full_name }} {{ kid.institution }}
                    <font-awesome-icon
                      :icon="['fas', 'chevron-down']"
                      class="ml-1"
                    />
                  </template>
                  <div class="text-xs whitespace-normal">
                    {{ kid.city }}
                    <br />
                    <span v-if="kid.institution">
                      {{ kid.unit }}
                    </span>
                    <span v-else>
                      {{ kid.hospital }}
                      <br />
                      <template v-if="kid.division">
                        {{ kid.division }}
                        <br />
                      </template>
                      {{ kid.ward }} (palata)
                      <br />
                      {{ kid.source }}
                    </span>
                  </div>
                  <div
                    v-if="
                      !kid.volunteers.length && currentUser.role !== 'volunteer'
                    "
                    class="mt-2 hide-on-print"
                  >
                    <base-btn-text
                      class="py-2 px-3"
                      @click="onClickAddVolunteer(kid)"
                    >
                      Pridėti savanorį
                    </base-btn-text>
                  </div>
                </td>
                <td v-if="expandedKids[kid.id]">
                  <!-- eslint-disable -->
                  <div v-for="volunteer in kid.volunteers" class="flex">
                    <div
                      class="flex-1 mb-1"
                      :class="{ 'pt-2': !showPhoneNumbers }"
                    >
                      <a
                        v-if="
                          currentUser.role !== 'volunteer' &&
                          !volunteer.archived_at
                        "
                        @click="onClickEditVolunteer(kid, volunteer.id)"
                        class="inline-block"
                      >
                        {{ volunteer.first_name }}
                        {{ volunteer.last_name.slice(0, 3) }}.
                      </a>
                      <div v-else class="h-8 flex items-center">
                        {{ volunteer.first_name }}
                        {{ volunteer.last_name.slice(0, 3) }}.
                      </div>
                      <div
                        v-if="showPhoneNumbers"
                        class="text-xs -mt-1 opacity-75"
                      >
                        ({{ volunteer.phone }})
                      </div>
                    </div>
                    <div
                      v-for="(dutyCell, dayIndex) in dutyCells(
                        kid.id,
                        volunteer.user_id,
                      )"
                      :key="dayIndex"
                    >
                      <div
                        v-if="dutyCell.can_apply"
                        class="mr-1 mb-1 text-center w-20 h-8 flex items-center justify-center rounded text-xs"
                        :class="{
                          'bg-gray-400 text-gray-400': !dutyCell.color,
                          'bg-yellow-400 text-gray-700':
                            dutyCell.color === 'yellow',
                          'bg-orange-400 text-gray-700':
                            dutyCell.color === 'orange',
                          'bg-blue-400 text-white': dutyCell.color === 'blue',
                          'bg-purple-400 text-white':
                            dutyCell.color === 'purple',
                          'cursor-pointer': currentUser.role !== 'volunteer',
                        }"
                        @click="
                          onClickReserveTime(
                            kid.id,
                            volunteer.user_id,
                            dutyCell,
                          )
                        "
                      >
                        <template v-if="dutyCell.hours">
                          {{ dutyCell.hours }}
                        </template>
                        <span v-else>+</span>
                      </div>
                      <div
                        v-else
                        class="w-20 bg-gray-200 text-gray-200 h-8 rounded text-xs mb-1 mr-1"
                      >
                        <span>+</span>
                      </div>
                    </div>
                  </div>
                  <!-- eslint-enable -->

                  <div
                    v-if="
                      kid.volunteers.length && currentUser.role !== 'volunteer'
                    "
                    class="flex hide-on-print"
                  >
                    <div class="flex-1">
                      <base-btn-text
                        class="py-2"
                        @click="onClickAddVolunteer(kid)"
                      >
                        Pridėti savanorį
                      </base-btn-text>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <base-dialog
      v-if="dialogs.volunteer.visible"
      :title="
        dialogs.volunteer.action === 'edit'
          ? 'Pakeisti savanorį'
          : 'Pridėti savanorį'
      "
      :overlay-closes="true"
      @close="dialogs.volunteer.visible = false"
    >
      <base-label-select
        v-model="dialogs.volunteer.volunteerId"
        :options="filteredVolunteerOptions()"
        class="w-full mt-4"
        :label="
          dialogs.volunteer.action === 'edit'
            ? 'Pakeiskite savanorį kitu'
            : 'Priskirkite savanorį vaikui'
        "
        required
      >
      </base-label-select>

      <template v-slot:buttons>
        <div
          v-if="dialogs.volunteer.action === 'edit'"
          class="w-60 relative cursor-pointer flex flex-column"
        >
          <base-btn
            type="danger"
            class="ml-4 p-3"
            @click="onClickDeleteVolunteer"
          >
            Pašalinti
          </base-btn>
          <base-btn class="ml-4 p-3" @click="onSubmitVolunteer">
            Pakeisti
          </base-btn>
        </div>
        <div v-else class="w-40 relative cursor-pointer ml-4">
          <base-btn class="p-3" @click="onSubmitVolunteer">
            Pridėti savanorį
          </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.shift.visible"
      :title="
        dialogs.shift.action === 'add'
          ? 'Užregistruoti pamainą'
          : 'Redaguoti pamainą'
      "
      :overlay-closes="true"
      @close="onCloseShiftsDialog"
    >
      <base-label-select
        v-model="dialogs.shift.shiftId"
        label="Pamaina"
        :options="freeShiftOptions"
        required
        class="w-full mt-4 mb-4"
        :error="dialogs.shift.modifyTime && !dialogs.shift.shiftId"
        @change="onShiftChange"
      >
      </base-label-select>

      <base-label-check
        v-model="dialogs.shift.modifyTime"
        label="Koreguoti budėjimo laiką"
        class="mb-4"
      />

      <div v-if="dialogs.shift.modifyTime" class="lg:flex lg:flex-column">
        <base-label-text
          label="Laikas nuo (val:min)"
          required
          class="lg:flex-1 lg:mr-2 mb-4"
        >
          <div class="flex flex-row">
            <base-select
              v-model="dialogs.shift.hourFrom"
              :options="hoursFromOptions"
              class="flex-1"
            >
            </base-select>
            <base-select
              v-model="dialogs.shift.minuteFrom"
              :options="minuteOptions"
              class="flex-1 ml-1"
            >
            </base-select>
          </div>
        </base-label-text>

        <base-label-text
          label="Laikas iki (val:min)"
          required
          class="lg:flex-1 lg:ml-2 mb-4"
        >
          <div class="flex flex-row">
            <base-select
              v-model="dialogs.shift.hourTo"
              :options="hoursToOptions"
              class="flex-1"
            >
            </base-select>
            <base-select
              v-model="dialogs.shift.minuteTo"
              :options="minuteOptions"
              class="flex-1 ml-1"
            >
            </base-select>
          </div>
        </base-label-text>
      </div>

      <template v-slot:buttons>
        <div
          v-if="dialogs.shift.action === 'update'"
          class="w-64 ml-4 cursor-pointer"
        >
          <base-btn class="p-3" type="danger" @click="onSubmitDutyDelete">
            Pašalinti
          </base-btn>
        </div>
        <div class="w-64 ml-4 cursor-pointer">
          <base-btn class="p-3" @click="onSubmitDutyTake">
            {{
              dialogs.shift.action === 'add'
                ? 'Registruoti pamainą'
                : 'Išsaugoti'
            }}
          </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.update.visible"
      title="Redaguoti pamainas"
      :overlay-closes="true"
      @close="dialogs.update.visible = false"
    >
      <base-label-text label="Budėjimai šią dieną:"> </base-label-text>

      <div class="flex flex-column">
        <div
          v-for="duty in dialogs.update.dutyCell.duties"
          :key="duty.id"
          class="flex-1 mr-2"
        >
          <base-btn class="p-3" @click="onClickDutyEdit(duty)">
            {{ duty.hours }}
          </base-btn>
        </div>

        <div class="w-56">
          <base-btn
            type="secondary"
            class="p-3"
            @click="
              onClickAddTime(
                dialogs.update.kidId,
                dialogs.update.userId,
                dialogs.update.dutyCell, // eslint-disable-line
              )
            "
          >
            <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />
            Pridėti pamainą
          </base-btn>
        </div>
      </div>
    </base-dialog>

    <base-dialog
      v-if="dialogs.reason.visible"
      title="Atšaukimo priežastis"
      :overlay-closes="true"
      @close="dialogs.reason.visible = false"
    >
      <base-label-input
        v-model="dialogs.reason.text"
        label="Jeigu atšaukimas įvyksta dėl savanorio kaltės, įrašykite priežastį:"
        placeholder="Komentaras..."
        class="w-full mt-4"
      />

      <template v-slot:buttons>
        <div class="w-40 relative cursor-pointer ml-4">
          <base-btn class="p-3" @click="onSubmitCancelReason">
            Atšaukti
          </base-btn>
        </div>
      </template>
    </base-dialog>
  </Layout>
</template>
